import * as React from 'react';
import { imageBaseURL } from '../../common/constants/CommonConstants';
import { CommonUtils } from '../../common/util/CommonUtils';
import PropTypes from 'prop-types';
import { PriceSection } from '../../common/components/PriceSection';

// For Lazy Loading
import { LazyLoadImage } from 'react-lazy-load-image-component';

export class StandaloneContentComponent extends React.Component {

    constructor(props) {
        super(props);
        this.commonUtils = new CommonUtils();
    }

    getStandaloneContent(id, standaloneContents) {
        if (!standaloneContents || standaloneContents.length < 1) return null;

        return standaloneContents.filter(content => content.id === id)[0];
    }

    renderDescription(content) {
        return(
            <div className={'description'}>
                <div className={`image-section img-${content.imagePosition ? content.imagePosition : 'left'}`}>
                    <picture><LazyLoadImage alt={content.altText || ''} src={imageBaseURL + content.imageURL} /></picture>
                </div>
                <div className={'desc-notes-section'}>
                    {this.renderDescNotes(content)}
                    {this.renderCTASection(content)}
                    {this.props.pricingDetails && this.props.pricingDetails.length > 0 ?
                        <PriceSection contentId={content.id} pricingDetails={this.props.pricingDetails} /> :
                        null
                    }
                </div>
            </div>
        );
    }

    renderDescNotes(content) {
        const description = content.description;
        if(!description.notes) return null;

        return (
            <ul className={'desc-notes'} id={`desc-notes-${content.id}`}> 
                {
                    description.notes.map((note, index) => <li key={`desc-note-${index}`}>{this.commonUtils.scanForHTMLElement(note)}</li>)
                }
                {
                    description.createOnAppText && description.createOnAppText !== '' ?
                        <li className="create-on-app-text">
                            {description.createOnAppText}
                        </li> : null
                }
            </ul>
        );
    }

    renderCTASection(content) {
        if(!content.ctaLink && content.ctaLink === '') return null;
        const ariaDescribedby = `section-heading-${content.id} section-sub-heading-${content.id} desc-notes-${content.id} price-section-${content.id}`;


        return(
            <div className={content.isCTAButton ? 'btn' : 'cta-link'}>
                <a href={content.ctaLink} className={content.isCTAButton ? 'uig-button uig-primary-button' : ''} aria-describedby={ariaDescribedby}>
                    {content.ctaLinkLable}
                </a>
            </div>
        );
    }

    render() {
        const standaloneContent = this.getStandaloneContent(this.props.id, this.props.standaloneContents);

        return standaloneContent && standaloneContent.active ? (
            <div className={`standalone-content-container${this.props.className && this.props.className !== '' ? ` ${this.props.className}` : ''}`}>
                <div id={standaloneContent.id} key={standaloneContent.id} className={'standalone-content'}>
                    <h2 className={'section-heading'} id={`section-heading-${standaloneContent.id}`}>
                        {standaloneContent.isNew ? <span className={'new-badge'}>NEW </span> : null}
                        {standaloneContent.heading}
                    </h2>
                    <div className={'section-sub-heading'} id={`section-sub-heading-${standaloneContent .id}`}>{standaloneContent.subHeading}</div>
                    {this.renderDescription(standaloneContent)}
                </div>
            </div>
        ) : null;
    }
}

StandaloneContentComponent.propTypes = {
    standaloneContents: PropTypes.array.isRequired,
    id: PropTypes.string.isRequired,
    className: PropTypes.string,
    pricingDetails: PropTypes.array
};

StandaloneContentComponent.defaultProps = {
    className: '',
    pricingDetails: []
};

